import { useCallback, useEffect, useRef, useState } from "react";
import { SpeechBubbleToast } from "@ever-tutor/et-ui";
import { useNotepadStore } from "../store/useNotepadStore";
import {
  createEagerTransport,
  disposeEagerTransport,
} from "@/canvas/agent/eagerTransport";

const TOAST_DURATION = 10;

const OpenNotepadIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="38" height="38" rx="19" fill="#E2FFE3" />
    <path
      d="M24.2205 7.83099C24.4216 7.64354 24.7329 7.65041 24.9255 7.84662L28.2078 11.1904C28.3996 11.3858 28.4067 11.7006 28.2234 11.9042L19.491 21.6054L19.4753 21.621C18.8328 22.2737 18.0561 22.7736 17.2009 23.0839L17.1306 23.1093C16.4185 23.3678 15.7715 23.7842 15.2361 24.3281L13.1824 26.4199C12.9835 26.6222 12.6606 26.6222 12.4617 26.4199L12.3533 26.3095L11.4509 27.2304C11.3041 27.3797 11.0847 27.4218 10.8972 27.3437L10.8191 27.3027L8.90698 26.08C8.77559 25.9961 8.68986 25.8558 8.67261 25.7001C8.65545 25.5447 8.7092 25.3895 8.81812 25.2783L10.0789 23.9921L9.96948 23.8808C9.77166 23.6793 9.77161 23.3529 9.96948 23.1513L12.1492 20.9316C12.6336 20.4391 13.0151 19.8512 13.2703 19.204L13.4861 18.6601L13.6082 18.373C13.9086 17.7101 14.3222 17.1059 14.8308 16.5888L14.8484 16.5712L24.2205 7.83099ZM9.98804 25.5497L11.0164 26.2079L11.6355 25.5781L10.7976 24.7245L9.98804 25.5497ZM11.0486 23.5165L12.822 25.3222L13.2898 24.8456L11.5164 23.04L11.0486 23.5165ZM13.3796 21.0693C13.2218 21.2767 13.053 21.4755 12.8708 21.6611L12.2351 22.3076L14.0085 24.1132L14.5144 23.5986C14.7404 23.3689 14.9845 23.1585 15.2429 22.9677L13.3796 21.0693ZM15.4744 17.4003C15.027 17.8757 14.6717 18.4331 14.4304 19.0449L14.2156 19.5898C14.1359 19.7914 14.0441 19.9877 13.9441 20.1796L16.1404 22.4179C16.3514 22.3118 16.5671 22.216 16.7888 22.1357L16.8591 22.1103C17.5685 21.8525 18.2143 21.4385 18.7488 20.8974L18.824 20.8124L15.4744 17.4003ZM16.2185 16.6953L19.5115 20.0488L27.1433 11.5703L24.5486 8.9267L16.2185 16.6953Z"
      fill="#1C9C6D"
      stroke="#1C9C6D"
      strokeWidth="0.2"
    />
    <path
      d="M22.6812 12.6501C22.8832 12.5196 23.1549 12.5428 23.3315 12.7194C23.5335 12.9214 23.5352 13.2477 23.3354 13.4518V13.4528L21.2505 15.5368C21.047 15.7402 20.7177 15.7403 20.5142 15.5368C20.3109 15.3333 20.3107 15.004 20.5142 14.8004L22.5981 12.7155H22.5991L22.6812 12.6501Z"
      fill="#1C9C6D"
      stroke="#1C9C6D"
      strokeWidth="0.2"
    />
    <path
      d="M25.0798 27.1824C26.2238 27.1824 26.8096 27.8034 27.3044 28.325C27.5328 28.5658 27.7272 28.7697 27.9568 28.9158C28.1823 29.0594 28.4449 29.1483 28.8093 29.1483C29.1088 29.1484 29.3306 29.4194 29.3308 29.7264C29.3308 30.0335 29.1089 30.3053 28.8093 30.3055C27.6653 30.3055 27.0791 29.6845 26.5847 29.1629C26.3562 28.9221 26.162 28.7174 25.9324 28.5711C25.7069 28.4275 25.4443 28.3387 25.0798 28.3387C24.7153 28.3387 24.4528 28.4275 24.2273 28.5711C23.9977 28.7174 23.8033 28.9221 23.575 29.1629C23.0802 29.6845 22.4938 30.3055 21.3503 30.3055C20.207 30.3053 19.6212 29.6844 19.1267 29.1629C18.8983 28.9221 18.7038 28.7174 18.4744 28.5711C18.2491 28.4276 17.9869 28.3388 17.6228 28.3387C17.2585 28.3387 16.9957 28.4275 16.7703 28.5711C16.5407 28.7174 16.3463 28.9221 16.1179 29.1629C15.6234 29.6844 15.0376 30.3054 13.8943 30.3055C12.7505 30.3055 12.1641 29.6846 11.6697 29.1629C11.4414 28.9221 11.2478 28.7173 11.0183 28.5711C10.7929 28.4275 10.5301 28.3387 10.1658 28.3387C9.8662 28.3386 9.64437 28.0677 9.64429 27.7606C9.64429 27.4534 9.86615 27.1825 10.1658 27.1824C11.3095 27.1824 11.8957 27.8031 12.3904 28.325C12.6185 28.5656 12.8124 28.7697 13.0417 28.9158C13.2672 29.0594 13.5299 29.1483 13.8943 29.1483C14.2584 29.1482 14.5205 29.0593 14.7458 28.9158C14.9754 28.7697 15.17 28.5657 15.3982 28.325C15.8928 27.8031 16.479 27.1824 17.6228 27.1824C18.7663 27.1826 19.3518 27.8032 19.8464 28.325C20.0748 28.5658 20.2693 28.7696 20.4988 28.9158C20.724 29.0593 20.9861 29.1482 21.3503 29.1483C21.7148 29.1483 21.9774 29.0593 22.2029 28.9158C22.4324 28.7697 22.627 28.5658 22.8552 28.325C23.3502 27.8034 23.9359 27.1825 25.0798 27.1824Z"
      fill="#1C9C6D"
      stroke="#1C9C6D"
      strokeWidth="0.2"
    />
  </svg>
);

export function OpenNotepadToast({ blobBottom }: { blobBottom?: number } = {}) {
  const { state, openFromToast, dismissToast } = useNotepadStore();
  const storeVisible = state === "TOAST_VISIBLE";
  const [dismissing, setDismissing] = useState(false);
  const [countdown, setCountdown] = useState(TOAST_DURATION);
  const [progressKey, setProgressKey] = useState(0);
  const pendingActionRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    if (storeVisible) {
      setDismissing(false);
      setCountdown(TOAST_DURATION);
      setProgressKey((k) => k + 1);
      createEagerTransport();
    }
  }, [storeVisible]);

  useEffect(() => {
    if (!storeVisible || dismissing) return;
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          pendingActionRef.current = () => {
            disposeEagerTransport();
            dismissToast();
          };
          setDismissing(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [storeVisible, dismissing, dismissToast]);

  const handleConfirm = useCallback(() => {
    pendingActionRef.current = () => openFromToast();
    setDismissing(true);
  }, [openFromToast]);

  const handleExitComplete = useCallback(() => {
    const action = pendingActionRef.current;
    pendingActionRef.current = null;
    action?.();
  }, []);

  const visible = storeVisible && !dismissing;

  return (
    <SpeechBubbleToast
      open={visible}
      top={blobBottom}
      progressDurationS={TOAST_DURATION}
      progressKey={progressKey}
      onExitComplete={handleExitComplete}
      aria-label="Open notepad prompt"
    >
      <div
        style={{
          padding: "17px 17px 14px 17px",
          display: "flex",
          flexDirection: "column",
          gap: 14,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 12,
            marginBottom: "10px",
          }}
        >
          <div style={{ flexShrink: 0, alignSelf: "center" }}>
            <OpenNotepadIcon />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p
              style={{
                margin: 0,
                fontSize: 16,
                fontWeight: 700,
                color: "#1a1a1a",
                lineHeight: 1.35,
                whiteSpace: "pre-line",
              }}
            >
              {"Want me to explain\nthis on the Notepad?"}
            </p>
            <p
              style={{
                margin: "5px 0 0",
                fontSize: 13,
                fontWeight: 500,
                color: "#999",
              }}
            >
              {`Closing in ${countdown}s`}
            </p>
          </div>
        </div>

        <button
          onClick={handleConfirm}
          style={{
            width: "100%",
            padding: "11px 0",
            background: "#1C9C6D",
            color: "#FFFFFF",
            border: "none",
            borderRadius: 10,
            fontSize: 16,
            fontWeight: 700,
            cursor: "pointer",
            letterSpacing: 0.1,
          }}
        >
          Continue in Notepad
        </button>
      </div>
    </SpeechBubbleToast>
  );
}
